const getPreferenceCenterCountrySelect = require("./getPreferenceCenterCountrySelect");

/**
 * @param preferenceCenter {HTMLElement}
 * @return {string}
 */
module.exports = function PreferenceCenter_getSelectedCountryOption(preferenceCenter) {
    const countrySelect = getPreferenceCenterCountrySelect(preferenceCenter);
    return countrySelect.value;
}